import { Link } from "react-router-dom";

import Shell from "../components/Shell";

export default function SmsTermsPage() {
  return (
    <Shell plain showGrid={false}>
      <main className="mx-auto w-full max-w-3xl px-6 py-12 text-text">
        <p className="text-sm font-semibold text-text-secondary">
          Team Housing Solutions
        </p>
        <h1 className="mt-3 text-3xl font-semibold">THS Lodging SMS Terms</h1>
        <div className="mt-8 space-y-7 text-base leading-7 text-text-secondary [&_h2]:mb-2 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-text">
          <section aria-labelledby="sms-program">
            <h2 id="sms-program">About the program</h2>
            <p>
              When you opt in, Team Housing Solutions may send automated texts
              about your current and future reservations and stays, including
              reservation confirmations and changes, arrival and check-in
              information, checkout reminders, service updates affecting your
              stay, and responses to lodging-support requests. This program does
              not include marketing or promotional messages.
            </p>
            <p className="mt-3">
              Participation is optional and is not required to make a
              reservation, check in, or receive lodging services. Providing a
              phone number alone does not enroll you. Enrollment continues until
              you unsubscribe. If you previously agreed only to checkout
              reminders, that consent remains limited to checkout reminders
              unless you explicitly agree to the broader lodging program.
            </p>
          </section>
          <section aria-labelledby="sms-frequency">
            <h2 id="sms-frequency">Frequency and charges</h2>
            <p>
              Message frequency varies based on your reservations, stays, and
              support requests. Enrollment confirmations and responses to STOP
              or HELP may also be sent. Message and data rates may apply to
              texts you send or receive. Contact your wireless provider about
              your text or data plan.
            </p>
          </section>
          <section aria-labelledby="sms-stop">
            <h2 id="sms-stop">Stop messages</h2>
            <p>
              Reply STOP to a text from this program at any time to unsubscribe.
              You will receive a final text acknowledging your cancellation, and
              lodging texts from this program will stop. Unsubscribing does not
              cancel or change your reservation. Contact Basecamp staff if you
              later want help enrolling again.
            </p>
          </section>
          <section aria-labelledby="sms-help">
            <h2 id="sms-help">Get help</h2>
            <p>
              Reply HELP to a text from this program for support and unsubscribe
              instructions. You can also email{" "}
              <a
                className="text-accent underline"
                href="mailto:info@teamhousing.com"
              >
                info@teamhousing.com
              </a>{" "}
              or call{" "}
              <a className="text-accent underline" href="tel:+18306098855">
                830-609-8855
              </a>
              . Contact Basecamp staff directly to change departure plans.
              Replying to a reminder does not change your reservation.
            </p>
          </section>
          <section aria-labelledby="sms-delivery">
            <h2 id="sms-delivery">Message delivery</h2>
            <p>
              This program is intended for US mobile numbers. Availability and
              delivery depend on your wireless provider and service. Delivery is
              not guaranteed. Carriers are not liable for delayed or undelivered
              messages.
            </p>
          </section>
          <section aria-labelledby="sms-privacy">
            <h2 id="sms-privacy">Privacy</h2>
            <p>
              See the{" "}
              <a
                className="text-accent underline"
                href="https://www.teamhousing.com/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                Team Housing Solutions Privacy Policy
              </a>{" "}
              for information about how we handle personal information.
            </p>
          </section>
        </div>
        <nav
          aria-label="Return to Basecamp"
          className="mt-10 flex flex-wrap gap-3 border-t border-separator pt-6"
        >
          <Link to="/" className="text-accent underline">
            Guest portal
          </Link>
          <Link to="/kiosk" className="text-accent underline">
            Return to kiosk
          </Link>
        </nav>
      </main>
    </Shell>
  );
}
